import { type ReactNode, useEffect, useState } from "react";

import { getMe, login, type User } from "../lib/auth.ts";

export interface AuthState {
	user: User | null;
	loading: boolean;
}

export function RequireAuth({ children }: { children: ReactNode }) {
	const [state, setState] = useState<AuthState>({ user: null, loading: true });

	useEffect(() => {
		(async () => {
			try {
				const user = await getMe();
				if (!user) {
					login();
					return;
				}
				setState({ user, loading: false });
			} catch (err) {
				console.error("auth check failed", err);
				login();
			}
		})();
	}, []);

	if (state.loading) {
		return (
			<div className="flex h-full items-center justify-center text-zinc-500">
				Authenticating...
			</div>
		);
	}

	return <>{children}</>;
}
